import { createAsyncThunk } from "@reduxjs/toolkit";
import { DispatchErrorHandler } from "../configs";
import servicesAPI from "../api/servicesAPI";

export const sendImportExportServiceEnquiry = createAsyncThunk(
  "servicesReducer/sendImportExportServiceEnquiry",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response =
        await servicesAPI.services.sendImportExportServiceEnquiry(payload);
      return response || null;
    } catch (error) {
      DispatchErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);

export const sendMigrationServiceEnquiry = createAsyncThunk(
  "servicesReducer/sendMigrationServiceEnquiry",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await servicesAPI.services.sendMigrationServiceEnquiry(
        payload
      );
      return response || null;
    } catch (error) {
      DispatchErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);
export const sendResidenceServiceEnquiry = createAsyncThunk(
  "servicesReducer/sendResidenceServiceEnquiry",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await servicesAPI.services.sendResidenceServiceEnquiry(
        payload
      );
      return response || null;
    } catch (error) {
      DispatchErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);
export const sendBusinessServiceEnquiry = createAsyncThunk(
  "servicesReducer/sendBusinessServiceEnquiry",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await servicesAPI.services.sendBusinessServiceEnquiry(
        payload
      );
      return response || null;
    } catch (error) {
      DispatchErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);
export const sendRealEstateServiceEnquiry = createAsyncThunk(
  "servicesReducer/sendRealEstateServiceEnquiry",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await servicesAPI.services.sendRealEstateServiceEnquiry(
        payload
      );
      return response || null;
    } catch (error) {
      DispatchErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);
export const sendConsultingServiceEnquiry = createAsyncThunk(
  "servicesReducer/sendConsultingServiceEnquiry",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await servicesAPI.services.sendConsultingServiceEnquiry(
        payload
      );
      return response || null;
    } catch (error) {
      DispatchErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);
export const sendWorkAbroadServiceEnquiry = createAsyncThunk(
  "servicesReducer/sendWorkAbroadServiceEnquiry",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await servicesAPI.services.sendWorkAbroadServiceEnquiry(
        payload
      );
      return response || null;
    } catch (error) {
      DispatchErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);
export const sendPropertyManagementServiceEnquiry = createAsyncThunk(
  "servicesReducer/sendPropertyManagementServiceEnquiry",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response =
        await servicesAPI.services.sendPropertyManagementServiceEnquiry(
          payload
        );
      return response || null;
    } catch (error) {
      DispatchErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);
export const sendRelocationSupportServiceEnquiry = createAsyncThunk(
  "servicesReducer/sendRelocationSupportServiceEnquiry",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response =
        await servicesAPI.services.sendRelocationSupportServiceEnquiry(payload);
      return response || null;
    } catch (error) {
      DispatchErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);
export const sendMedicalTourismServiceEnquiry = createAsyncThunk(
  "servicesReducer/sendMedicalTourismServiceEnquiry",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response =
        await servicesAPI.services.sendMedicalTourismServiceEnquiry(payload);
      return response || null;
    } catch (error) {
      DispatchErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);
export const senContactSubmissionDetails = createAsyncThunk(
  "servicesReducer/senContactSubmissionDetails",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response =
        await servicesAPI.services.senContactSubmissionDetails(payload);
      return response || null;
    } catch (error) {
      DispatchErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);
